import { Component, Input } from '@angular/core';

import { SnChannel } from '../../../models';

@Component({
  selector: 'sn-channel-list-item',
  templateUrl: './channel-list-item.component.html',
  styleUrls: ['./channel-list-item.component.scss'],
})
export class SnChannelListItemComponent {
  @Input()
  public channel: SnChannel;

  @Input()
  public activated: boolean;

  constructor() {}

  get unconsumedMessagesCount(): string | number {
    return this.channel.unconsumedMessagesCount >= 10 ? '9+' : this.channel.unconsumedMessagesCount;
  }
}
